import React from "react";
import WelcomeMessage from "./src/welcomeMessage";
import StarQuestions from "./src/starQuestions";
import RateViaOtherChannels from "./src/rateViaOtherChannels";
import SpeakWithCoachQuestions from "./src/speakWithCoachQuestions";
import PersonalFeedback from "./src/personalFeedback";
import SubmitRatingButton from "./src/submitRatingButton";
import AdditionalQuestions from "./src/additionalQuestions";
import FreeTextInput from "./src/freeTextInput";
import EndMessage from "./src/endMessage";
import Section from "../../../components/section/section";

const RateAppointmentContainer = (): React.JSX.Element => (
  <Section>
    <WelcomeMessage />
    <StarQuestions />
    <RateViaOtherChannels />
    <PersonalFeedback />
    <SpeakWithCoachQuestions />
    <AdditionalQuestions />
    <FreeTextInput />
    <EndMessage />
    <SubmitRatingButton />
  </Section>
);

export default RateAppointmentContainer;
